module.exports = __webpack_public_path__ + "img/VIJAYANAGAR.c0e0bf6c.jpg";